export default "/images/05 Step1Assess-Consultant-To view completed self-assessments-03.png?7e07d8d173e25ce47bcb88cafe488df5";